import SectionHeading from "@/components/base/SectionHeading";
import GoogleReviewCard from "@/components/feature/GoogleReviewCard";
import { googleRating, googleReviews } from "@/mocks/reviews";

export default function TestimonialsSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Testimonials"
          title="What Our Client&apos;s Say?"
          subtitle="Real 5-star reviews from families and businesses we have moved across Karnataka, straight from our Google Business profile."
        />

        {/* Google rating summary */}
        <div className="mx-auto mt-9 flex max-w-3xl flex-col items-center gap-5 rounded-lg border border-background-200 bg-background-50 px-6 py-6 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
          <div className="flex items-center gap-4">
            <span className="font-heading text-5xl font-bold leading-none text-foreground-950">
              {googleRating.score}
            </span>
            <span className="h-12 w-px bg-background-200" aria-hidden="true" />
            <div>
              <span className="flex gap-0.5 text-secondary-500" aria-label="Rated 5 out of 5 on Google">
                {[0, 1, 2, 3, 4].map((star) => (
                  <i key={star} className="ri-star-fill text-base" aria-hidden="true" />
                ))}
              </span>
              <span className="mt-1.5 block text-xs text-foreground-600">
                Based on <strong className="font-semibold text-foreground-800">{googleRating.total} Google reviews</strong>
              </span>
            </div>
          </div>

          <a
            href={googleRating.profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-heading text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-google-fill text-base" aria-hidden="true" />
            Read all reviews on Google
          </a>
        </div>

        {/* Reviews grid */}
        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {googleReviews.map((review) => (
            <GoogleReviewCard key={review.name} review={review} />
          ))}
        </div>
      </div>
    </section>
  );
}